import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login, user, checked } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (checked && user) nav("/admin");
  }, [checked, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-5" style={{ background: "var(--ink)" }} data-testid="admin-login-page">
      <div className="w-full max-w-md p-10" style={{ background: "var(--bone)" }}>
        <div className="flex items-center gap-2 mb-8">
          <ShieldCheck size={28} style={{ color: "var(--orange)" }} />
          <span className="font-display font-extrabold text-2xl">ALDOL-SOLUTIONS<span style={{ color: "var(--orange)" }}>.</span> Admin</span>
        </div>
        <h1 className="font-display font-bold text-3xl mb-2">Espace administration</h1>
        <p className="mb-8" style={{ color: "var(--ink-2)" }}>Connectez-vous pour gérer votre site.</p>
        <form onSubmit={submit} className="space-y-4">
          <input className="field" type="email" placeholder="Email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
          <input className="field" type="password" placeholder="Mot de passe" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
          {error && <p className="text-sm" style={{ color: "var(--orange-hover)" }} data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full py-4 font-semibold" data-testid="login-submit">
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
      </div>
    </div>
  );
}
